module.exports = __webpack_public_path__ + "static/project-19b-e369681473ec169a09f53074237543c7.png";